import type { FaireProductEntity } from "../../entity_types/product";

export const p_y3m5n8as6y: FaireProductEntity = {
  token: "p_y3m5n8as6y",
  type: "product",
  name: "Mini Cable Sweater Knit Baby Blanket (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl: "https://cdn.faire.com/fastly/6f1712b78b2008516ebd1f23c21945680e3e202ea3328df1179a61e5f22ed121.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4e037c166a35ea7dc4c6bc5bffad45d7b9d4d0141e751746f98ef189573eca8.jpeg",
    "https://cdn.faire.com/fastly/c20b1565a15371a2a1a61f7bd4cdbe9e8a9fee347ad722835f69858987751859.jpeg",
    "https://cdn.faire.com/fastly/f80c4dacbe8219ac8d8c7856f377e364da05a57d4b830f2ef519505898d1978f.jpeg"
  ],
  priceDollars: 26,
  description: "100% organic cotton, sweater knit, ultra-soft - mini cable knit baby blanket in natural color. \nPackaged in natural muslin gift bag. Perfect for gifting. \nLuxurious and refined handfeel.\nOne Size - 32x40\"\nAll-season, lightweight, breathable cotton, cozy, comfy.\nChemical free & non-toxic formulation.\nClassic and adorable design with meticulous detailing.\nAvailable in many charming and adorable colors.\nEthically made in India from small farmer sourced organic cotton.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:19.524Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
